import { Box, Grid, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import useAPI from "../../../../api/hooks/useAPI";
import useIsIntegrated from "../../../../api/hooks/useIsIntegrated";
import { slackKeys } from "../../../../api/queryKeys";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";
import SecondaryButton from "../../../../components/buttons/SecondaryButton";
import useExpandedList from "../../../../components/hooks/ExpandedList";
import LoadingIcon from "../../../../components/LoadingIcon";
import { ORGANIZATION_NOTIFICATIONS_TAB } from "../../../settings/SettingsView";
import { logos } from "../../environment/icons/iconExport";
import Guideline from "../components/Guideline";
import GuidelineStep from "../components/GuidelineStep";
import GuidelineStepByStep from "../components/GuidelineStepByStep";
import IntegrationGuideAlert from "../components/IntegrationGuideAlert";

export default function SlackIntegration() {
  const [searchParams] = useSearchParams();
  const [guideMode, setGuideMode] = useState(false);
  useEffect(() => {
    if (searchParams.has("viewonly")) {
      setGuideMode(true);
    }
  }, [searchParams]);
  const { handleExpandAll, handleCollapseAll } = useExpandedList();

  const { fetchSlackAuthUrl, trackEvent } = useAPI();
  const navigate = useNavigate();

  const { isIntegrated, isIntegratedLoading } = useIsIntegrated("slack");

  const slackAuthUrl = useQuery({
    queryKey: slackKeys.authUrl(),
    queryFn: fetchSlackAuthUrl,
    select: (response) => response.data,
    enabled: !isIntegrated,
  });

  const loading = isIntegratedLoading || slackAuthUrl.isLoading;
  const handleSettingsNavigation = (control_id) => {
    trackEvent(
      ` user clicked on go to settings from slack integration page`
    ).then();
    navigate(`/settings?tab=${ORGANIZATION_NOTIFICATIONS_TAB}`);
  };
  return (
    <Box>
      <Guideline
        title={!isIntegrated ? "Integrate with Slack" : ""}
        image={logos.SlackLogo}
        name={"Slack"}
        content={
          loading || isIntegratedLoading ? (
            <LoadingIcon size={25} />
          ) : isIntegrated && !guideMode ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
              }}
            >
              <Typography variant={"h4"}>
                Slack integration successful!
              </Typography>
              <Typography variant={"body1"}>
                You can now receive notifications from Breeze in your Slack
                workspace. Customize your notification preferences anytime in
                the Notification Center.
              </Typography>
              <Box>
                <PrimaryButton onClick={handleSettingsNavigation}>
                  Go to Notification Center
                </PrimaryButton>
              </Box>
            </Box>
          ) : (
            <>
              <Box mb="20px">
                <Grid container spacing={2} direction={"row"}>
                  {guideMode && <IntegrationGuideAlert />}

                  <Grid item>
                    <SecondaryButton onClick={handleExpandAll}>
                      Expand All Screenshots
                    </SecondaryButton>
                  </Grid>
                  <Grid item>
                    <SecondaryButton onClick={handleCollapseAll}>
                      Collapse All Screenshots
                    </SecondaryButton>
                  </Grid>
                </Grid>
              </Box>
              <GuidelineStepByStep>
                <GuidelineStep title="Login with a user account that has the necessary permissions to add the Slack application to the Slack workspace"></GuidelineStep>
                <GuidelineStep title="Add the Breeze App to Slack">
                  <Box style={{ display: "flex" }}>
                    <PrimaryButton
                      onClick={() => {
                        window.open(slackAuthUrl.data, "_blank");
                      }}
                      disabled={guideMode}
                    >
                      Add to Slack
                    </PrimaryButton>
                  </Box>
                </GuidelineStep>
                <GuidelineStep title="Approve the application addition request on Slack"></GuidelineStep>
              </GuidelineStepByStep>
            </>
          )
        }
      />
    </Box>
  );
}
